import React from 'react';
import '../assets/css/fonts.css';

import SEO from '../components/seo';
import Footer from '../components/footer';
import Menu from '../components/menu';
import Hamburger from '../components/hamburger';

import style from '../assets/css/main.module.css';

class CGV extends React.Component {
    render() {
        return (
            <div id="top">
                <SEO
                    title="Conditions générales de vente | MDS Digital Agency"
                    canonical="https://www.mds-digitalagency.be/cgv/"
                    description="Conditions générales de vente de MDS Digital Agency. Téléchargement en PDF disponible."
                    keywords="cgv, conditions générales de vente, MDS Digital Agency"
                />

                <div className={style.main}>
                    <Menu />
                    <div className={style.menu_mobile}>
                        <Hamburger />
                    </div>

                    {/* Contenu page */}
                    <section className={[style.row].join(' ')} style={{ paddingTop: '140px' }}>
                        <div className={style.container}>
                            <h1 className={style.home_title}>Conditions générales de vente</h1>

                            <p style={{ marginTop: 16 }}>
                                Vous pouvez consulter nos conditions générales de vente ci-dessous ou les télécharger au format PDF.
                            </p>

                            <div style={{ marginTop: 18 }}>
                                <a
                                    href="/docs/CGV_MDS_2026_Final.pdf"
                                    download
                                    style={{
                                        display: 'inline-block',
                                        padding: '12px 18px',
                                        borderRadius: 999,
                                        border: '1px solid rgba(255,255,255,0.35)',
                                        textDecoration: 'none',
                                    }}
                                >
                                    Télécharger les CGV (PDF)
                                </a>
                            </div>

                            <div style={{ marginTop: 30, lineHeight: 1.75, opacity: 0.95 }}>
                                <h2 style={{ marginTop: 24 }}>
                                    <strong>1. Généralités</strong>
                                </h2>
                                <p>Les conditions générales (ci-après indiquées « CGV »)
                                    ci-après sont applicables même au cas où elles
                                    seraient en contradiction avec les CGV ou particulières
                                    des cocontractants de MDS-PROCONSULT SPRL (ci-
                                    après : « MDS »). Ces dernières n’engagent dès lors
                                    MDS que si celle-ci les a acceptées en termes exprès,
                                    non équivoques et par écrit. Les présentes CGV et les
                                    conditions particulières, accompagnant et/ou figurant
                                    au recto et/ou au verso de l'offre, du devis, du bon de
                                    commande, et/ou de la facture constituent l'entièreté
                                    des accords ou complètent les autres contrats conclus
                                    entre parties. Elles s’appliquent à toutes relations
                                    présentes et futures, en vertu d’accords tant écrits
                                    qu’échangés par voie électronique (mail,
                                    messageries,…). Les présentes CGV s’appliquent à
                                    toutes les relations contractuelles conclues après leur
                                    entrée en vigueur ainsi qu’aux relations en cours pour
                                    leurs effets futurs, sous réserve des dispositions
                                    contractuelles antérieures expressément convenues.
                                    Sauf mention expresse contraire, le délai de validité des
                                    offres, devis, etc., de MDS est de 30 jours. Toute
                                    commande ne sera effective qu’après confirmation
                                    expresse de la part de MDS. MDS est autorisée à
                                    mentionner le Client dans sa liste de références, sauf
                                    refus du client, notifié par écrit avant la première
                                    publication. Cet accord implique toute mention,
                                    utilisation de logos, etc. du client, sur tous supports,
                                    notamment audio, vidéo, papier, ainsi que sur Internet
                                    ou tout autre media. Les présentes CGV forment un
                                    ensemble indissociable. Le fait pour une partie de ne
                                    pas invoquer, à un moment donné, une disposition des
                                    présentes CGV ou d’un contrat conclu entre parties, ne
                                    pourra jamais être réputé être une renonciation à
                                    invoquer ces dispositions ultérieurement. Outre son
                                    adhésion aux présentes CGV, le client déclare adhérer
                                    sans réserve aux CGV des fabricants/éditeurs de
                                    logiciels tiers éventuellement utilisés par MDS. En cas
                                    de discordance entre les CGV de l’éditeur et les
                                    présentes, ces dernières seront d’application dans les
                                    relations entre MDS et ses clients. Tous engagements
                                    du client à l’égard de MDS seront établis à suffisance
                                    par tout écrit, message, mail émanant du client, de
                                    même que par tout mail émanant de MDS (non
                                    contesté dans les 48h par le client) et confirmant un
                                    entretien verbal entre parties. La nullité d’une
                                    quelconque disposition des présentes conditions
                                    générales ou d’un autre contrat intervenu entre parties
                                    ne rendra pas nul l’intégralité de l’acte concerné. La
                                    disposition concernée sera simplement réputée non
                                    écrite. Les parties s’entendront aux fins de remplacer la
                                    disposition incriminée par une disposition d’égale
                                    portée.
                                </p>

                                <h2 style={{ marginTop: 24 }}>
                                    <strong>2. Acceptation électronique</strong>
                                </h2>
                                <p> Le client reconnaît et accepte que toute acceptation,
                                    validation ou confirmation effectuée par voie
                                    électronique (notamment par signature électronique,
                                    validation en ligne, échange d’e-mails, messages via
                                    des outils de gestion de projet, messageries
                                    électroniques ou toute autre communication
                                    numérique) ait la même valeur juridique qu’une
                                    signature manuscrite.
                                    Toute commande, validation de devis, instruction ou
                                    confirmation transmise par voie électronique engage
                                    valablement le client et vaut acceptation des présentes
                                    Conditions Générales de Vente, sauf contestation
                                    écrite et motivée notifiée à MDS dans un délai de
                                    quarante-huit (48) heures.
                                </p>

                                <h2 style={{ marginTop: 24 }}>
                                    <strong>3. Définition de la mission de MDS</strong>
                                </h2>
                                <p>Après étude des informations fournies par le client,
                                    MDS propose la solution la mieux adaptée aux besoins
                                    décrits par celui-ci. MDS s’engage donc à fournir les
                                    produits et services en fonction des besoins que le
                                    client estime devoir couvrir et des renseignements qu’il
                                    a fournis à MDS. Sauf dans les cas où cela fait
                                    expressément partie de la mission confiée à MDS, le
                                    client est tenu de s'être personnellement documenté à
                                    suffisance ou de s'être fait assister d'un conseil afin de
                                    définir les produits et services permettant de répondre
                                    à l’ensemble de ses besoins. MDS ne garantit donc
                                    nullement que les produits et/ou services fournis
                                    permettront de couvrir l'ensemble des besoins du client.
                                    Sauf indications contraires, le système/service livré
                                    sera présumé conforme à sa destination convenue, tant
                                    actuelle que future. Le client est conscient que les offres
                                    et devis de MDS ne comprennent que ce qui y est
                                    clairement indiqué par écrit, à l’exclusion de tout
                                    matériel, logiciel ou prestation complémentaire qui n’y
                                    figureraient pas. Tout supplément sollicité par le client,
                                    par rapport à ce qui est indiqué au bon de commande
                                    ou au contrat, fera l’objet d’une facturation
                                    complémentaire. En cas de fin de contrat de service,
                                    MDS s'engage à collaborer loyalement aux éventuelles
                                    opérations de migration vers un autre prestataire, pour
                                    autant que le client démontre que les modalités
                                    proposées ne portent pas préjudice aux droits
                                    (notamment de propriété intellectuelle) et intérêts de
                                    MDS. Les prestations, dans ce cadre, seront facturées
                                    en régie.
                                </p>

                                <h2 style={{ marginTop: 24 }}>
                                    <strong>4. Intervention des services, réparations, maintenance par MDS</strong>
                                </h2>
                                <p>En cas d'intervention, sauf contrat de maintenance
                                    spécifique, toutes les prestations seront effectuées en
                                    régie, selon un tarif qui peut être communiqué à la première demande. Le temps nécessaire aux prestations facturées par MDS sera suffisamment établi
                                    par la production soit d’un « time sheet » indiquant le temps presté, soit d’un bordereau d’intervention chez
                                    le client signé par celui-ci ou son préposé. Le prix des prestations de MDS est toujours mentionné pour des
                                    prestations effectuées en ses bureaux. En cas de prestation hors de ses bureaux, les tarifs seront
                                    majorés de 10%, et calculés à partir du départ du siège de MDS jusqu’au retour au même siège, outre des frais
                                    de déplacement, les éventuels frais de parking et d’hébergement et tous autres frais justifiés par la mission.
                                </p>

                                <h2 style={{ marginTop: 24 }}>
                                    <strong>5. Référencement</strong>
                                </h2>
                                <p>Lorsque MDS travaille sur le référencement naturel du
                                    client, MDS mettra tout en œuvre pour rencontrer les objectifs de son client. Aucune garantie ne peut
                                    toutefois être donnée. Lors des référencements payants (exemple : Google Ads, Facebook Ads,…), le
                                    client paiera anticipativement les montants de publicité prévus et la commission de MDS.
                                </p>

                                <h2 style={{ marginTop: 24 }}>
                                    <strong>6. Propriété intellectuelle</strong>
                                </h2>
                                <p>MDS est spécialisée dans la digitalisation sur mesure :
                                    conception et réalisation de sites, d’applications
                                    mobiles, de plateformes et logiciels web, ainsi que la
                                    gestion, la modification et l’adaptation de plateformes et
                                    logiciels existants. Les droits d’auteur et tous les autres
                                    éléments de propriété intellectuelle de toute
                                    conception, réalisation et /ou transformation desdits
                                    plateformes ou logiciels par MDS ou ses sous-traitants
                                    éventuels, sont et restent la propriété de MDS, quel
                                    que soit le stade d’avancement de la mission confiée à
                                    MDS par le client et même après réalisation complète
                                    et paiement par le client. Les droits patrimoniaux sur les
                                    développements spécifiques réalisés pour le client sont
                                    concédés au client sous forme de licence d’utilisation
                                    telle que définie ci-après. MDS conserve la propriété de
                                    ses frameworks, briques logicielles, méthodes, codes
                                    génériques et savoir-faire. MDS concède, au client
                                    ayant satisfait à toutes ses obligations vis-à-vis de
                                    MDS, une licence personnelle non exclusive et non
                                    cessible d’utilisation de la création de MDS. MDS peut
                                    avoir déjà utilisé et conserve le droit d’utiliser ses
                                    propres productions, et toutes leurs composantes (codes,…)
                                    dans d’autres applications que celles du client.
                                    Le client déclare être propriétaire et
                                    /ou détenteur des droits suffisants pour autoriser MDS à utiliser,
                                    dans ses créations, le contenu textuel et
                                    audiovisuel qu’il donne à MDS aux fins de reproduction ou modification.
                                </p>

                                <h2 style={{ marginTop: 24 }}>
                                    <strong>7. Responsabilité vis-à-vis des logiciels tiers</strong>
                                </h2>
                                <p>MDS n’assume aucune responsabilité concernant les
                                    logiciels libres et/ou ceux développés par d’autres
                                    éditeurs ni ne s’engage à disposer du personnel apte à
                                    intervenir sur lesdits logiciels. L'obligation de MDS se
                                    limite à transmettre au client les notices, modes
                                    d'emploi ou documentations fournies par le fabricant, la
                                    maison d'édition ou de distribution du produit fourni.
                                </p>

                                <h2 style={{ marginTop: 24 }}>
                                    <strong>8. Formation du client</strong>
                                </h2>
                                <p>La vente et la livraison des produits et services
                                    n'entraînent pas pour MDS une quelconque obligation
                                    de formation du client à l'utilisation du produit fourni.
                                    Dans tous les cas, sauf mention contraire, la formation
                                    éventuelle du client ou de son personnel est toujours
                                    facturée en supplément.
                                </p>

                                <h2 style={{ marginTop: 24 }}>
                                    <strong>9. Garanties</strong>
                                </h2>
                                <p>En dehors des garanties fournies par MDS sur ses
                                    prestations, et qui figurent dans les contrats particuliers,
                                    le client est conscient que les garanties sur logiciels
                                    sont exclusivement celles délivrées par les fabricants et
                                    éditeurs des logiciels. L'éventuelle perte de données
                                    par le client n'est jamais couverte par aucune garantie.
                                    Seules les modifications et interventions effectuées par
                                    nos soins, ou à notre intervention, sont garanties par
                                    nous, pendant la durée indiquée aux contrats
                                    particuliers ou, à défaut, jusqu’à la fin de ces contrats.
                                    MDS n’est jamais responsable des conséquences
                                    directes ou indirectes résultant des modifications
                                    apportées par le client lui-même (exemple : CMS,
                                    Google Ads,…) aux éléments mis en place par MDS.
                                    MDS ne peut être tenu pour responsable d’une
                                    défaillance d’un prestataire externe (tels : Wordpress,
                                    OVH, Facebook, Instagram, Linked’in,…) Le client
                                    décharge MDS de toute responsabilité pour tout
                                    dommage de quelque nature que ce soit, direct ou
                                    indirect, matériel ou immatériel, manque à gagner,
                                    pertes de données, etc… liés à la conception, aux
                                    fonctionnalités, à la mise en œuvre et à l’utilisation des
                                    logiciels, contenus digitaux et plateforme internet
                                    fournis, vendus ou mis à disposition. MDS mettra
                                    néanmoins tout en œuvre (obligation de moyens) pour
                                    tenter de trouver une solution à tout problème que
                                    pourrait rencontrer le client dans l’utilisation des
                                    logiciels et sites concernés. Dans tous les cas où la
                                    responsabilité de MDS serait mise en cause et établie,
                                    seule sa faute lourde ou intentionnelle pourrait lui être
                                    reprochée. Dans ce cas, le total des indemnités à
                                    charge de MDS ne pourrait, de convention expresse,
                                    dépasser 10% du montant facturé pour le logiciel ou la
                                    prestation qui est à l’origine du dommage. En aucun cas
                                    MDS ne pourra être tenue responsable des préjudices
                                    indirects, qui ne résultent pas directement et
                                    exclusivement de la défaillance du service fourni par
                                    MDS, tels que préjudice commercial, perte de
                                    commandes ou de bénéfices, atteinte à l’image de
                                    marque, etc… Le client est seul responsable de la
                                    licéité des contenus qu’il communique à MDS en vue
                                    de publication. Le client garantit qu’il dispose tous les
                                    droits l’autorisant à en permettre la diffusion par MDS.
                                    MDS n’est jamais responsable du respect, par le client,
                                    des règles du RGPD (règlementation sur les données
                                    personnelles). Il appartient au seul client de se mettre
                                    en règle et d’utiliser les outils adéquats.
                                </p>

                                <h2 style={{ marginTop: 24 }}>
                                    <strong>10. Modalités de paiement</strong>
                                </h2>
                                <p>Nos prix s'entendent en EURO, hors taxes, et ils
                                    incluent les seuls travaux, prestations et fournitures,
                                    expressément désignés ou décrits par la commande
                                    acceptée, à l'exclusion de tous autres. L’estimation de
                                    prix donnée dans notre offre ou devis pourra varier
                                    ensuite en fonction d’éventuelles
                                    modifications/adaptations demandées par le client en
                                    cours de développement, ainsi qu’en fonction des
                                    éventuels modules supplémentaires nécessaires au
                                    fonctionnement optimum de l’application concernée.
                                    Sauf mention expresse contraire, nos factures sont
                                    payables dans les trente jours suivant la date de la
                                    facture, net et sans escompte, au siège social de
                                    l’activité. La souscription d'effets n'opère pas novation.
                                    Les factures d’acomptes sont payables au comptant.
                                    Toutes autres factures sont payables à 30 jours date de
                                    facture. Tout défaut de paiement à l'échéance,
                                    demande de sursis de paiement, ou tout autre fait
                                    pouvant laisser prévoir l'insolvabilité du client,
                                    entraînent d'office la déchéance de tout terme accordé
                                    pour le paiement de tout service, livré ou en cours et
                                    rendent ces paiements immédiatement exigibles. Ces
                                    circonstances nous autorisent, de plein droit, sans
                                    préavis ni mise en demeure préalable, soit de résilier
                                    les marchés en cours, soit de bloquer les accès au site
                                    ou à la plateforme du client, soit de retenir les
                                    prestations commandées, sans autre formalité qu'une
                                    notification par lettre recommandée à la poste et sans
                                    que cela puisse donner lieu, pour le client, au moindre
                                    dédommagement. En cas de résiliation fautive du
                                    contrat par le client, ou en cas de résiliation par MDS
                                    en raison de la faute du client, ce dernier sera redevable
                                    à MDS de l’intégralité du montant qui aurait été dû si le
                                    contrat avait été mené à terme. Toute somme impayée
                                    à son échéance sera majorée de plein droit et sans
                                    mise en demeure préalable d'une indemnité forfaitaire
                                    et irrévocable d'un montant de 10% du solde restant
                                    dû avec un minimum de 250 € sans préjudice de tous
                                    autres dommages et/ou intérêts, ainsi que d’un intérêt
                                    moratoire au taux de 1% par mois, tout mois entamé
                                    étant dû en entier. Tout paiement partiel sera imputé
                                    par priorité sur les frais et indemnités, ensuite sur les
                                    intérêts échus et enfin sur le capital, conformément à
                                    l'article 1254 du Code Civil, nonobstant le contenu de
                                    tout décompte et de toute imputation intermédiaire
                                    antérieurement communiquée.
                                </p>

                                <h2 style={{ marginTop: 24 }}>
                                    <strong>11. Délais</strong>
                                </h2>
                                <p>Nos délais de livraison et d'exécution sont donnés de
                                    bonne foi mais à titre indicatif, sans engagement ferme.
                                    Ils ne peuvent prendre cours qu'à partir de la date de
                                    l'accord du client sur le contrat, ainsi qu'après mise à
                                    notre disposition de tous renseignements nécessaires
                                    à l'exécution. Les délais d'exécution ou de livraison sont
                                    suspendus par tous cas fortuits ou de force majeure,
                                    auxquels sont conventionnellement assimilées toutes
                                    circonstances indépendantes de notre volonté et non
                                    constitutives d'une faute dans notre chef qui pourraient
                                    arrêter, suspendre ou interrompre l'exécution d'un
                                    marché ou d'une livraison. Notamment, des périodes
                                    de congé, des demandes complémentaires du client
                                    pourraient allonger les délais. Nous pourrons, le cas
                                    échéant, prolonger les délais d'exécution ou de
                                    livraison en cas de retard de paiement par le client. Si,
                                    après signature de la commande ou d’un contrat
                                    spécifique, l'exécution de travaux supplémentaires ou
                                    de modifications est demandée, les délais initialement
                                    prévus seront caducs. Si la modification des délais
                                    entraîne des frais supplémentaires, ceux-ci seront
                                    portés en compte au client. Le client s’engage à tout
                                    mettre en œuvre pour permettre à MDS d’exécuter ses
                                    prestations dans les délais convenus. Le client veillera
                                    notamment à permettre à MDS d’accéder normalement
                                    à ses installations, serveurs, etc… lorsque c’est
                                    nécessaire, pour installer les matériels et logiciels, ou
                                    pour effectuer les interventions/ maintenances aux
                                    dates prévues. Le client mettra à disposition de MDS
                                    une personne de contact unique, disponible et réactive,
                                    disposant des pouvoirs pour valider ou rejeter les
                                    prestations réalisées par MDS dans les délais et via les
                                    outils convenus. Sans préjudice de l’application de
                                    l’article 9, en cas d’obstruction du client aux prestations
                                    de MDS, et après mise en demeure du client restée
                                    sans suite positive endéans les 8 jours, MDS pourra
                                    réclamer le paiement immédiat des prestations déjà
                                    effectuées et, en outre, le client sera redevable à MDS
                                    d’une indemnité forfaitaire de 500 € par jour, sans
                                    préjudice du droit de MDS d’établir un préjudice
                                    supérieur.
                                </p>

                                <h2 style={{ marginTop: 24 }}>
                                    <strong>12. Réclamations</strong>
                                </h2>
                                <p>Sans préjudice des dispositions prévues aux contrats
                                    particuliers, toute réclamation doit nous être communiquée
                                    par lettre recommandée endéans les huit jours de la
                                    réception des produits/services. L'utilisation d'une partie de
                                    la fourniture entraîne également de plein droit l'acceptation
                                    de la totalité. Les défauts d'une partie de la livraison ne
                                    donnent pas droit au client de refuser la totalité de la
                                    fourniture. Sans préjudice des dispositions de l’article 4,
                                    toutes fournitures, marchandises ou réalisations
                                    quelconques restent notre propriété jusqu'au paiement
                                    intégral du prix convenu et de toute somme due en vertu
                                    des contrats en cours.
                                </p>

                                <h2 style={{ marginTop: 24 }}>
                                    <strong>13. Non sollicitation</strong>
                                </h2>
                                <p>Pendant toute la durée des relations commerciales entre
                                    MDS et son client, ainsi que durant une période d’un an
                                    suivant la dernière intervention de MDS chez le client, MDS
                                    et le client s'engagent réciproquement à ne recruter
                                    directement ou indirectement aucun Membre du personnel
                                    et/ou sous-traitant de l’autre partie ou à ne pas lui faire
                                    exécuter des travaux ne faisant pas l'objet d'un contrat entre
                                    le client et MDS, sauf accord écrit préalable. Le non-respect
                                    de cette interdiction donnera lieu à des dommages intérêts
                                    fixés de façon forfaitaire à un an de salaire brut du membre
                                    du personnel concerné ou douze fois le montant du barème
                                    mensuel du sous-traitant concerné. Une même
                                    indemnisation est due par la Partie au cas où elle arriverait
                                    au même résultat de quelque autre façon que ce soit avec
                                    l'intention de contourner cette interdiction.
                                </p>

                                <h2 style={{ marginTop: 24 }}>
                                    <strong>14. Compétence / droit applicable</strong>
                                </h2>
                                <p>Le présent contrat est soumis au droit belge. En cas de
                                    différend et à défaut d’accord amiable tout litige relevant
                                    de l’exécution ou de l’interprétation de la présente
                                    convention sera de la compétence exclusive des
                                    tribunaux de l’arrondissement judiciaire du Hainaut,
                                    Division de Mons (Belgique). Les traductions éventuelles
                                    des présentes conditions générales sont fournies à titre
                                    indicatif. En cas de divergence entre des versions de
                                    langues différentes, le texte en français prévaudra.
                                </p>

                                <h2 style={{ marginTop: 24 }}>
                                    <strong>15. Réversibilité – remise des livrables</strong>
                                </h2>
                                <p>En cas de cessation de la relation contractuelle, pour
                                    quelque cause que ce soit, et sous réserve du paiement
                                    intégral de toutes les sommes dues à MDS, celle-ci
                                    s’engage à mettre à disposition du client les livrables
                                    expressément prévus dans le devis ou le contrat ou, à
                                    défaut, les livrables explicitement identifiés comme tels
                                    dans les échanges écrits entre parties, dans l’état où ils
                                    se trouvent au moment de la fin de la collaboration.
                                    Sauf stipulation contraire, cette remise comprend les
                                    éléments nécessaires à la poursuite de l’exploitation du
                                    projet par le client ou par un tiers, à l’exclusion des outils
                                    internes, frameworks, bibliothèques, méthodes,
                                    composants génériques, codes sources réutilisables et
                                    plus largement du savoir-faire propre à MDS.
                                    Toute prestation de réversibilité, d’assistance à la
                                    migration, de transfert de compétences ou de
                                    collaboration avec un prestataire tiers est effectuée en
                                    régie, sur base des tarifs en vigueur, et pour autant que
                                    ces opérations ne portent pas atteinte aux droits et
                                    intérêts légitimes de MDS, notamment en matière de
                                    propriété intellectuelle et de confidentialité.
                                </p>
                            </div>
                        </div>
                    </section>
                </div>

                <Footer />
            </div>
        );
    }
}

export default CGV;